import React from "react";

import { reportClientError } from "../../services/clientErrorReporter";
import {
  FallbackAction,
  FallbackContainer,
  FallbackMessage,
  FallbackTitle,
} from "./styles";

type ErrorBoundaryProps = {
  children: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = {
    hasError: false,
  };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    void reportClientError({
      message: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack ?? undefined,
      source: "error-boundary",
      route: globalThis.location?.pathname,
      userAgent: globalThis.navigator?.userAgent,
    });
  }

  private handleReload = () => {
    globalThis.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <FallbackContainer role="alert">
          <FallbackTitle>Something went wrong</FallbackTitle>
          <FallbackMessage>Refresh the page and try again.</FallbackMessage>
          <FallbackAction type="button" onClick={this.handleReload}>
            Refresh
          </FallbackAction>
        </FallbackContainer>
      );
    }

    return this.props.children;
  }
}
